// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d3f31e6","455":"0cb54713"}[chunkId] + ".chunk.js";
};